import type { FC } from 'react';
import { msg } from '@gonfalon/messages/msg';
import { IconButton, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

export const SpanDetailsIconButton: FC<{ onPress: () => void }> = ({ onPress }) => (
  <TooltipTrigger delay={300}>
    <IconButton
      icon="terminal"
      aria-label={msg('vega.conversation.showDetails')}
      variant="minimal"
      size="small"
      onPress={onPress}
    />
    <Tooltip placement="top">{msg('vega.conversation.showDetails')}</Tooltip>
  </TooltipTrigger>
);
